import { type LoginLinkParams } from '@/src/domains/auth/schemas'

// Single owner of the precedence rule: a redirect target carried by the link wins over a plain
// query param appended to it.
export const resolveLoginRedirectUrl = (
  params: LoginLinkParams | undefined,
  queryRedirectUrl: string | undefined,
) => params?.redirectUrl ?? queryRedirectUrl
